import {Component, Input} from "@angular/core";
import {ValidationHelperService} from "../../../../core/helpers/validation-helper.service";
import {FormControl, FormGroup} from "@angular/forms";
import {EExerciseStartType} from "../../../../shared/enums/EExerciseStartType";
import {ECountdownEndType} from "../../../../shared/enums/ECountdownEndType";
import {EExerciseType} from "../../../../shared/enums/EExerciseType";
import {ECompanionMode} from "../../../../shared/enums/ECompanionMode";

@Component({
  selector: "app-countdowns-form",
  templateUrl: "./countdowns-form.component.html",
  styleUrls: ["./countdowns-form.component.scss"],
})
export class CountdownsFormComponent {
  @Input() _formGroup: FormGroup;
  @Input() _exerciseType: FormControl;
  @Input() _companionMode?: FormControl<ECompanionMode>;
  protected readonly ValidationHelperService = ValidationHelperService;

  onStartTypeChange(): void {
    this.startValue.setValue(null);
    this._formGroup.updateValueAndValidity();
  }

  get startType(): FormControl {
    return this._formGroup.get("startType") as FormControl;
  }

  get startValue(): FormControl {
    return this._formGroup.get("startValue") as FormControl;
  }

  get endType(): FormControl {
    return this._formGroup.get("endType") as FormControl;
  }

  get endValue(): FormControl {
    return this._formGroup.get("endValue") as FormControl;
  }

  get usesArrowCountdown(): boolean {
    return (
      this._exerciseType.value === EExerciseType.Agility ||
      (this._exerciseType.value === EExerciseType.Companion &&
        this._companionMode?.value === ECompanionMode.Agility)
    );
  }

  protected readonly EExerciseStartType = EExerciseStartType;
  protected readonly ECountdownEndType = ECountdownEndType;
  protected readonly EExerciseType = EExerciseType;
}
